import Vue from 'vue'
import Router from 'vue-router'
const BindAccount = resolve => require.ensure([], () => resolve(require('@/components/BindAccount')));
const CourseBooking = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseBooking')));

const ForeignClass = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/ForeignClass')));
const OneForeign = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/OneForeign')));
const ThreeForeign = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/ThreeForeign')));
const FourClass = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/FourClass')));
const GrammarClass = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/GrammarClass')));
const PlanClass = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/PlanClass')));
const PromotionClass = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/PromotionClass')));
const PlanHistory = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/PlanHistory')));
const PromotionHistory = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/CourseList/PromotionHistory')));


const openClass = resolve => require.ensure([], () => resolve(require('@/components/openClass/openClass')));
const MyCourse = resolve => require.ensure([], () => resolve(require('@/components/dateCourse/MyCourse')));
const loading = resolve => require.ensure([], () => resolve(require('@/components/loading')));
const callback = resolve => require.ensure([], () => resolve(require('@/components/callback')));

//老师公众号
const tloading = resolve => require.ensure([], () => resolve(require('@/components/tea/loading')));
const tcallback = resolve => require.ensure([], () => resolve(require('@/components/tea/callback')));
const tBindAccount = resolve => require.ensure([], () => resolve(require('@/components/tea/BindAccount')));


Vue.use(Router)
tBindAccount
export default new Router({
  mode:'history',//默认为hash
  routes: [
    {
      path: '/',
      name: 'BindAccount',
      component: BindAccount,
      meta: {
        title: '账号绑定'
      }
    },
    {
      path: '/dateCourse/CourseBooking',
      name: 'CourseBooking',
      component: CourseBooking,
      children:[
        {path:'/CourseBooking/OneForeign', component:OneForeign,meta: {title: '课程预约'}},
        {path:'/CourseBooking/ForeignClass',component:ForeignClass,meta: {title: '课程预约'}},
        {path:'/CourseBooking/ThreeForeign', component:ThreeForeign,meta: {title: '课程预约'}},
        {path:'/CourseBooking/GrammarClass', component:GrammarClass,meta: {title: '课程预约'}},
        {path:'/CourseBooking/PlanClass', component:PlanClass,meta: {title: '课程预约'}},
        {path:'/CourseBooking/PromotionClass', component:PromotionClass,meta: {title: '课程预约'}},
        {path:'/CourseBooking/FourClass', component:FourClass,meta: {title: '课程预约'}},
      ]
    },
    {
      path: '/dateCourse/CourseList/PlanHistory',
      name: 'PlanHistory',
      component: PlanHistory,
      meta: {
        title: '规划课历史'
      }
    },
    {
      path: '/dateCourse/CourseList/PromotionHistory',
      name: 'PromotionHistory',
      component: PromotionHistory,
      meta: {
        title: '晋级课历史'
      }
    },
    {
      path: '/openClass/openClass',
      name: 'openClass',
      component: openClass,
      meta: {
        title: '免费公开课'
      }
    },
    {
      path: '/dateCourse/MyCourse',
      name: 'MyCourse',
      component: MyCourse,
      meta: {
        title: '我的课程'
      }
    },
    {
      path: '/loading',
      name: 'loading',
      component: loading,
      meta: {
        title: '日本村外教网'
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: callback
    },
    {
      path: '/tea/loading',
      name: 'tloading',
      component: tloading,
      meta: {
        title: '日本村外教网'
      }
    },
    {
      path: '/tea/callback',
      name: 'tcallback',
      component: tcallback
    },
    {
      path: '/tea/index',
      name: 'BindAccount',
      component: tBindAccount,
      meta: {
        title: '账号绑定'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js